import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Card, Row, Col, Accordion } from 'react-bootstrap';
import UkiesAssets from '../Admin/UkiesAssets';

export default function Ukies22Block({ componentSettings, setComponentSettings, onChange, selectedComponent, setSelectedComponent, forms = [] }) {
    const [showAssetSelector, setShowAssetSelector] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [leftBodySourceCodeMode, setLeftBodySourceCodeMode] = useState(false);
    const [rightBodySourceCodeMode, setRightBodySourceCodeMode] = useState(false);

    const [contentHistory, setContentHistory] = useState({
        left_side: {
            text: { strapline: '', title: '', body: '', action_type: 'none', button_label: '', button_link: '', button_color: 'default', form_shortcode: '[form=1]' },
            image: { image_src: '' },
            map: { map_center_lat: '51.7103', map_center_lng: '5.1984', map_zoom: '13' }
        },
        right_side: {
            text: { strapline: '', title: '', body: '', action_type: 'none', button_label: '', button_link: '', button_color: 'default', form_shortcode: '[form=1]' },
            image: { image_src: '' },
            map: { map_center_lat: '51.7103', map_center_lng: '5.1984', map_zoom: '13' }
        }
    });
    const apiToken = process.env.REACT_APP_UKIES_API_TOKEN;
    const leftBodyEditorRef = useRef(null);
    const rightBodyEditorRef = useRef(null);
    
    // Get current values with defaults
    const layout = componentSettings.layout || {
        small_display: 'structure-1-reverse', // structure-1, structure-1-reverse, structure-2, structure-2-reverse
        large_display: 'lg:structure-2-reverse', // lg:structure-2, lg:structure-2-reverse
        image_position: 'left' // left or right
    };
    
    const leftSide = componentSettings.left_side || {
        type: 'image', // image, text, map
        hidden_on_small: false,
        content: {
            image_src: '',
            strapline: '',
            title: '',
            body: '',
            action_type: 'none', // none, button, form
            button_label: '',
            button_link: '',
            button_color: 'default',
            form_shortcode: '[form=1]',
            map_center_lat: '51.7103',
            map_center_lng: '5.1984',
            map_zoom: '13'
        }
    };
    
    const rightSide = componentSettings.right_side || {
        type: 'text', // image, text, map
        hidden_on_small: false,
        content: {
            image_src: '',
            strapline: '',
            title: '',
            body: '',
            action_type: 'none', // none, button, form
            button_label: '',
            button_link: '',
            button_color: 'default',
            form_shortcode: '[form=1]',
            map_center_lat: '51.7103',
            map_center_lng: '5.1984',
            map_zoom: '13'
        }
    };

    // Parse HTML content to extract block configuration
    const parseHTMLContent = (htmlContent) => {
        if (!htmlContent) return null;
        
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');
            
            const mainDiv = doc.querySelector('.ukies-2-2-block');
            if (!mainDiv) return null;
            
            const classes = Array.from(mainDiv.classList);
            
            // Extract layout classes
            const smallDisplayClass = classes.find(c => c.startsWith('structure-') && !c.startsWith('lg:'));
            const largeDisplayClass = classes.find(c => c.startsWith('lg:structure-'));
            
            // Determine image position based on order of components
            const components = Array.from(mainDiv.children);
            const imageComponent = components.find(comp => comp.classList.contains('component-image'));
            const textComponent = components.find(comp => comp.classList.contains('component-text'));
            
            const imagePosition = components.indexOf(imageComponent) === 0 ? 'left' : 'right';
            
            const config = {
                layout: {
                    small_display: smallDisplayClass || 'structure-1-reverse',
                    large_display: largeDisplayClass || 'lg:structure-2-reverse',
                    image_position: imagePosition
                },
                left_side: {
                    type: imagePosition === 'left' ? 'image' : 'text',
                    hidden_on_small: false,
                    content: {}
                },
                right_side: {
                    type: imagePosition === 'right' ? 'image' : 'text',
                    hidden_on_small: false,
                    content: {}
                }
            };
            
                         // Parse image content
             if (imageComponent) {
                 const img = imageComponent.querySelector('img');
                 const iframe = imageComponent.querySelector('iframe');
                 const sideKey = imagePosition === 'left' ? 'left_side' : 'right_side';
                 
                 if (img) {
                     config[sideKey].content.image_src = img.getAttribute('src') || '';
                 } else if (iframe) {
                     // Parse map iframe
                     config[sideKey].type = 'map';
                     const src = iframe.getAttribute('src') || '';
                     
                     // Extract zoom, center coordinates from Google Maps embed URL
                     const zoomMatch = src.match(/zoom=(\d+)/);
                     const centerMatch = src.match(/center=([0-9.-]+)%2C([0-9.-]+)/);
                     
                     if (zoomMatch) {
                         config[sideKey].content.map_zoom = zoomMatch[1];
                     }
                     if (centerMatch) {
                         config[sideKey].content.map_center_lat = centerMatch[1];
                         config[sideKey].content.map_center_lng = centerMatch[2];
                     }
                 }
             }
            
            // Parse text content
            if (textComponent) {
                const sideKey = imagePosition === 'left' ? 'right_side' : 'left_side';
                
                const straplineEl = textComponent.querySelector('.preheader-text');
                const titleEl = textComponent.querySelector('.header-text');
                const bodyEl = textComponent.querySelector('.body-text');
                const buttonEl = textComponent.querySelector('.component-button button');
                const linkEl = textComponent.querySelector('.component-button a');
                
                // Check for form - look in the entire text component
                const textContent = textComponent.innerHTML;
                const formMatch = textContent.match(/\[form=([^\]]+)\]/);
                
                let actionType = 'none';
                let formShortcode = '[form=1]';
                
                if (formMatch) {
                    actionType = 'form';
                    // Use the full shortcode match
                    formShortcode = formMatch[0];
                } else if (buttonEl && buttonEl.textContent.trim()) {
                    actionType = 'button';
                }
                
                config[sideKey].content = {
                    strapline: straplineEl ? straplineEl.textContent.trim() : '',
                    title: titleEl ? titleEl.textContent.trim() : '',
                    body: bodyEl ? bodyEl.innerHTML.trim() : '',
                    action_type: actionType,
                    button_label: buttonEl ? buttonEl.textContent.trim() : '',
                    button_link: linkEl ? linkEl.getAttribute('href') || '' : '',
                    button_color: buttonEl && buttonEl.classList.contains('highlight') ? 'highlight' : 'default',
                    form_shortcode: formShortcode
                };
            }
            
            return config;
        } catch (error) {
            console.error('Error parsing HTML content:', error);
            return null;
        }
    };

    // HTML escaping function
    const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    };



    // Generate HTML content from current form values
    const generateHTMLContent = () => {
        return generateHTMLContentWithSettings(componentSettings);
    };

    // Generate HTML content with specific settings
    const generateHTMLContentWithSettings = (settings) => {
        console.log('generateHTMLContentWithSettings called');
        const layoutData = settings.layout || layout;
        const leftSideData = settings.left_side || leftSide;
        const rightSideData = settings.right_side || rightSide;
        
        const mainClasses = ['structure', layoutData.small_display, layoutData.large_display, 'ukies-2-2-block'];
        
        // Determine which side has what content
        const sides = layoutData.image_position === 'left' 
            ? [leftSideData, rightSideData] 
            : [rightSideData, leftSideData];
        
        const components = sides.map((side, index) => {
            const hiddenClass = side.hidden_on_small ? ' hidden lg:flex' : '';
            
            if (side.type === 'image') {
                return `    <div class="component component-image${hiddenClass}">
        <img src="${side.content.image_src || ''}">
    </div>`;
            } else if (side.type === 'map') {
                const lat = side.content.map_center_lat || '51.7103';
                const lng = side.content.map_center_lng || '5.1984';
                const zoom = side.content.map_zoom || '13';
                const apiKey = 'AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8';
                
                return `    <div class="component component-image${hiddenClass}">
        <iframe style="border: 0px; width: 100%; height: 100%; min-height: 340px" frameborder="0" src="https://www.google.com/maps/embed/v1/view?zoom=${zoom}&amp;center=${lat}%2C${lng}&amp;key=${apiKey}"></iframe>
    </div>`;
            } else if (side.type === 'text') {
                let actionHtml = '';
                
                if (side.content.action_type === 'button' && side.content.button_label) {
                    const buttonClass = side.content.button_color === 'highlight' ? ' class="highlight"' : '';
                    actionHtml = `        <div class="component component-button">
            <a href="${escapeHtml(side.content.button_link || '')}">
                <button${buttonClass} type="button">${escapeHtml(side.content.button_label)}</button>
            </a>
        </div>`;
                } else if (side.content.action_type === 'form') {
                    // Use the form shortcode directly
                    const formShortcode = side.content.form_shortcode || '[form=1]';
                    
                    console.log('Generating form HTML - Form shortcode:', formShortcode);
                    
                    actionHtml = `        <hr style="margin-top:1rem">
        ${formShortcode}`;
                }
                
                return `    <div class="component component-text${hiddenClass}">
        <div class="preheader-text">
            ${escapeHtml(side.content.strapline || '')}
        </div>
        <div class="header-text">${escapeHtml(side.content.title || '')}</div>
        <div class="body-text justify">
            ${side.content.body || ''}
        </div>
${actionHtml}
    </div>`;
            }
            
            return `    <div class="component component-text${hiddenClass}">
        <div class="preheader-text"></div>
        <div class="header-text"></div>
        <div class="body-text justify"></div>
    </div>`;
        });

                 const htmlContent = `<div class="${mainClasses.join(' ')}">
${components.join('\n')}
</div>`;

         console.log('Generated HTML content:', htmlContent);
         return htmlContent;
    };

    // Initialize form values from HTML content on component mount
    useEffect(() => {
        if (selectedComponent?.content && !isInitialized) {
            const parsed = parseHTMLContent(selectedComponent.content);
            if (parsed) {
                setComponentSettings(prev => ({
                    ...prev,
                    layout: parsed.layout,
                    left_side: parsed.left_side,
                    right_side: parsed.right_side
                }));
            }
            setIsInitialized(true);
        }
    }, [selectedComponent?.content, isInitialized, setComponentSettings]);

    // Reset initialization when component changes
    useEffect(() => {
        setIsInitialized(false);
    }, [selectedComponent?.id]);

    // Update HTML content when settings change
    const updateHTMLContent = () => {
        console.log('updateHTMLContent called');
        const newContent = generateHTMLContent();
        
        setComponentSettings(prev => ({
            ...prev,
            content: newContent
        }));
        
        onChange('content', newContent);
    };

    // Update HTML content with specific settings (for immediate updates)
    const updateHTMLContentWithSettings = (settings) => {
        const newContent = generateHTMLContentWithSettings(settings);
        
        setComponentSettings(prev => ({
            ...prev,
            content: newContent
        }));
        
        onChange('content', newContent);
    };

    // Handle layout changes
    const handleLayoutChange = (key, value) => {
        const newLayout = { ...layout, [key]: value };
        const newComponentSettings = {
            ...componentSettings,
            layout: newLayout
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle side content changes
    const handleSideChange = (side, key, value) => {
        const sideKey = `${side}_side`;
        const currentSide = side === 'left' ? leftSide : rightSide;
        
        let newSide;
        if (key === 'type') {
            // Save current content to history before switching type
            const currentType = currentSide.type;
            const currentContent = currentSide.content;
            
            // Update content history with current content before switching
            setContentHistory(prev => ({
                ...prev,
                [sideKey]: {
                    ...prev[sideKey],
                    [currentType]: { ...currentContent }
                }
            }));
            
                         // Get content from history for the new type, or use defaults if not in history
             const defaultFormId = '1';
             const newTypeContent = contentHistory[sideKey]?.[value] || {
                 text: { strapline: '', title: '', body: '', action_type: 'none', button_label: '', button_link: '', button_color: 'default', form_shortcode: '[form=1]' },
                 image: { image_src: '' },
                 map: { map_center_lat: '51.7103', map_center_lng: '5.1984', map_zoom: '13' }
             }[value];
            
            newSide = {
                ...currentSide,
                type: value,
                content: { ...newTypeContent }
            };
        } else if (key === 'hidden_on_small') {
            newSide = { ...currentSide, [key]: value };
        } else {
            // Content changes - also update the content history for the current type
            const newContent = { ...currentSide.content, [key]: value };
            newSide = {
                ...currentSide,
                content: newContent
            };
            
            // Update content history for current type
            setContentHistory(prev => ({
                ...prev,
                [sideKey]: {
                    ...prev[sideKey],
                    [currentSide.type]: { ...newContent }
                }
            }));
        }
        
        // Update componentSettings
        const newComponentSettings = {
            ...componentSettings,
            [sideKey]: newSide
        };
        
        setComponentSettings(newComponentSettings);
        
        // Generate HTML immediately with the updated settings
        setTimeout(() => {
            console.log('handleSideChange triggering updateHTMLContentWithSettings');
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle asset selection
    const handleAssetSelect = (asset, side) => {
        const imageUrl = asset.image_variations?.large 
            ? asset.image_variations.large.replace('/large', '/max')
            : asset.url;
        
        handleSideChange(side, 'image_src', imageUrl);
        setShowAssetSelector(false);
    };

    // Format text functions for rich text editors
    const formatLeftBodyText = (command, value = null) => {
        document.execCommand(command, false, value);
        leftBodyEditorRef.current.focus();
    };

    const formatRightBodyText = (command, value = null) => {
        document.execCommand(command, false, value);
        rightBodyEditorRef.current.focus();
    };

    // Handle left body text change from contentEditable
    const handleLeftBodyTextChange = (e) => {
        const content = e.target.innerHTML;
        if (content === '<p>Voer hier de tekst in...</p>') {
            handleSideChange('left', 'body', '');
        } else {
            handleSideChange('left', 'body', content);
        }
    };

    // Handle right body text change from contentEditable
    const handleRightBodyTextChange = (e) => {
        const content = e.target.innerHTML;
        if (content === '<p>Voer hier de tekst in...</p>') {
            handleSideChange('right', 'body', '');
        } else {
            handleSideChange('right', 'body', content);
        }
    };

    // Handle left body editor click to clear placeholder
    const handleLeftBodyEditorClick = () => {
        if (leftBodyEditorRef.current && leftBodyEditorRef.current.innerHTML === '<p>Voer hier de tekst in...</p>') {
            leftBodyEditorRef.current.innerHTML = '<p><br></p>';
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(leftBodyEditorRef.current.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    // Handle right body editor click to clear placeholder
    const handleRightBodyEditorClick = () => {
        if (rightBodyEditorRef.current && rightBodyEditorRef.current.innerHTML === '<p>Voer hier de tekst in...</p>') {
            rightBodyEditorRef.current.innerHTML = '<p><br></p>';
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(rightBodyEditorRef.current.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    // Handle left body source code mode toggle
    const handleLeftBodySourceCodeToggle = () => {
        if (leftBodySourceCodeMode) {
            const sourceContent = leftBodyEditorRef.current.value;
            handleSideChange('left', 'body', sourceContent);
        } else {
            const wysiwygContent = leftBodyEditorRef.current.innerHTML;
            handleSideChange('left', 'body', wysiwygContent);
        }
        setLeftBodySourceCodeMode(!leftBodySourceCodeMode);
    };

    // Handle right body source code mode toggle
    const handleRightBodySourceCodeToggle = () => {
        if (rightBodySourceCodeMode) {
            const sourceContent = rightBodyEditorRef.current.value;
            handleSideChange('right', 'body', sourceContent);
        } else {
            const wysiwygContent = rightBodyEditorRef.current.innerHTML;
            handleSideChange('right', 'body', wysiwygContent);
        }
        setRightBodySourceCodeMode(!rightBodySourceCodeMode);
    };

    // Set initial content for body editors when data changes
    useEffect(() => {
        if (leftBodyEditorRef.current && leftSide.content.body !== undefined) {
            // Only update editor content if it's not currently focused (being edited)
            const isFocused = document.activeElement === leftBodyEditorRef.current;
            
            if (!isFocused) {
                if (leftBodySourceCodeMode) {
                    leftBodyEditorRef.current.value = leftSide.content.body || '';
                } else {
                    leftBodyEditorRef.current.innerHTML = leftSide.content.body || '<p>Voer hier de tekst in...</p>';
                }
            }
        }
    }, [leftSide.content.body, leftBodySourceCodeMode]);

    useEffect(() => {
        if (rightBodyEditorRef.current && rightSide.content.body !== undefined) {
            // Only update editor content if it's not currently focused (being edited)
            const isFocused = document.activeElement === rightBodyEditorRef.current;
            
            if (!isFocused) {
                if (rightBodySourceCodeMode) {
                    rightBodyEditorRef.current.value = rightSide.content.body || '';
                } else {
                    rightBodyEditorRef.current.innerHTML = rightSide.content.body || '<p>Voer hier de tekst in...</p>';
                }
            }
        }
    }, [rightSide.content.body, rightBodySourceCodeMode]);



    return (
        <div>
                         <style jsx>{`
                 .add-button-green {
                     background-color: var(--ukies-light-green) !important;
                     border-color: var(--ukies-light-green) !important;
                     color: white !important;
                 }
                 .add-button-green:hover:not(:disabled) {
                     background-color: var(--ukies-dark-green) !important;
                     border-color: var(--ukies-dark-green) !important;
                     color: white !important;
                 }
                 .rich-text-editor {
                     font-family: inherit;
                     font-size: 0.9rem;
                     line-height: 1.5;
                 }
                 .rich-text-editor:focus {
                     border-color: #80bdff !important;
                     box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
                 }
                 .rich-text-editor p {
                     margin-bottom: 0.5rem;
                 }
                 .rich-text-editor ul, .rich-text-editor ol {
                     margin-bottom: 0.5rem;
                     padding-left: 1.5rem;
                 }
                 .rich-text-editor a {
                     color: #007bff;
                     text-decoration: underline;
                 }
                 .accordion-button {
                     background-color: white !important;
                     border: 1px solid #dee2e6 !important;
                     padding-left: 3rem !important;
                     padding-right: 1.25rem !important;
                 }
                 .accordion-button:not(.collapsed) {
                     background-color: white !important;
                     color: inherit !important;
                     box-shadow: none !important;
                 }
                 .accordion-button:focus {
                     box-shadow: none !important;
                     border-color: #dee2e6 !important;
                 }
                 .accordion-button::after {
                     display: none !important;
                 }
                 .accordion-button::before {
                     content: '';
                     position: absolute;
                     left: 1.25rem;
                     top: 50%;
                     transform: translateY(-50%);
                     width: 0.5rem;
                     height: 0.5rem;
                     border-right: 2px solid currentColor;
                     border-bottom: 2px solid currentColor;
                     transform: translateY(-50%) rotate(45deg);
                     transition: transform 0.2s ease-in-out;
                 }
                 .accordion-button:not(.collapsed)::before {
                     transform: translateY(-50%) rotate(-135deg);
                 }
             `}</style>

                         
             {/* Layout Configuration */}
             <h6 className="mb-2 mt-4" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px' }}>
                 Layout instellingen
             </h6>
             
             <Row className="mb-3">
                 {/* Small Display Layout */}
                 <Col md={6}>
                     <Form.Group className="mb-3">
                         <Form.Label>Kleine schermen (mobiel)</Form.Label>
                         <Form.Select
                             value={layout.small_display}
                             onChange={(e) => handleLayoutChange('small_display', e.target.value)}
                         >
                             <option value="structure-1">Gestapeld - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} boven</option>
                             <option value="structure-1-reverse">Gestapeld - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} onder</option>
                             <option value="structure-2">Naast elkaar - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} links</option>
                             <option value="structure-2-reverse">Naast elkaar - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} rechts</option>
                         </Form.Select>
                     </Form.Group>
                 </Col>
     
                 {/* Large Display Layout */}
                 <Col md={6}>
                     <Form.Group className="mb-3">
                         <Form.Label>Grote schermen (desktop)</Form.Label>
                         <Form.Select
                             value={layout.large_display}
                             onChange={(e) => handleLayoutChange('large_display', e.target.value)}
                         >
                             <option value="lg:structure-2">Naast elkaar - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} links</option>
                             <option value="lg:structure-2-reverse">Naast elkaar - {leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'} rechts</option>
                         </Form.Select>
                     </Form.Group>
                 </Col>
             </Row>

                         <Accordion alwaysOpen className="my-4">
                 {/* Left Side Configuration */}
                 <Accordion.Item eventKey="0">
                     <Accordion.Header>
                         <strong>{leftSide.type === 'map' ? 'Kaart' : 'Afbeelding'}</strong>
                     </Accordion.Header>
                     <Accordion.Body>
                         <Row className="mb-3">
                             <Col md={8}>
                                 <Form.Group>
                                     <Form.Label>Type content</Form.Label>
                                     <Form.Select
                                         value={leftSide.type}
                                         onChange={(e) => handleSideChange('left', 'type', e.target.value)}
                                     >
                                         <option value="image">Afbeelding</option>
                                         <option value="map">Kaart</option>
                                     </Form.Select>
                                 </Form.Group>
                             </Col>
                             <Col md={4}>
                                 <Form.Group>
                                     <Form.Label>Verberg op mobiel</Form.Label>
                                     <Form.Check
                                         type="switch"
                                         checked={leftSide.hidden_on_small}
                                         onChange={(e) => handleSideChange('left', 'hidden_on_small', e.target.checked)}
                                     />
                                 </Form.Group>
                             </Col>
                         </Row>


                 {leftSide.type === 'image' && (
                 <>
                     <Form.Group className="mb-3">
                         <Form.Label>Afbeelding</Form.Label>
                         <div className="d-flex align-items-center gap-2 mb-2">
                             <Button 
                                 variant="outline-secondary" 
                                 onClick={() => setShowAssetSelector('left')}
                                 style={{ 
                                     filter: 'grayscale(100%)',
                                     minWidth: '35.2px',
                                     height: '35.2px',
                                     padding: '0',
                                     display: 'flex',
                                     alignItems: 'center',
                                     justifyContent: 'center'
                                 }}
                             >
                                 🖼️
                            </Button>
                            <Form.Control
                                type="text"
                                value={leftSide.content.image_src || ''}
                                onChange={(e) => handleSideChange('left', 'image_src', e.target.value)}
                                placeholder="Voer afbeelding URL in"
                                disabled
                            />
                         </div>
                         {leftSide.content.image_src && (
                             <div className="mt-2">
                                 <img 
                                     src={leftSide.content.image_src} 
                                     alt="Preview" 
                                     style={{ 
                                         width: '100%', 
                                        //  maxHeight: '200px',
                                         objectFit: 'cover',
                                         border: '1px solid #dee2e6',
                                         borderRadius: '4px',
                                         cursor: 'pointer'
                                     }}
                                     onClick={() => window.open(leftSide.content.image_src, '_blank')}
                                 />
                             </div>
                         )}
                     </Form.Group>
                 </>
             )}

             {leftSide.type === 'map' && (
                 <>
                     <Form.Group className="mb-3">
                         <Form.Label>Kaart preview</Form.Label>
                         <div className="mt-2">
                             <iframe 
                                 style={{ 
                                     width: '100%', 
                                     height: '200px',
                                     border: '1px solid #dee2e6',
                                     borderRadius: '4px'
                                 }}
                                 frameBorder="0"
                                 src="https://www.google.com/maps/embed/v1/view?zoom=13&center=51.7103%2C5.1984&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                             />
                         </div>
                         <small className="text-muted">
                             Standaard locatie: Nederland (51.7103, 5.1984) - Zoom niveau 13
                         </small>
                     </Form.Group>
                                   </>
              )}
                     </Accordion.Body>
                 </Accordion.Item>

                                   {/* Right Side Configuration */}
                  <Accordion.Item eventKey="1">
                      <Accordion.Header>
                          <strong>Tekst</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                          <Row className="mb-3">
                              <Col md={8}>
                                  <Form.Group>
                                      <Form.Label>Type content</Form.Label>
                                      <Form.Select
                                          value={rightSide.type}
                                          onChange={(e) => handleSideChange('right', 'type', e.target.value)}
                                          disabled
                                      >
                                          <option value="text">Tekst</option>
                                      </Form.Select>
                                  </Form.Group>
                              </Col>
                             <Col md={4}>
                                 <Form.Group>
                                     <Form.Label>Verberg op mobiel</Form.Label>
                                     <Form.Check
                                         type="switch"
                                         checked={rightSide.hidden_on_small}
                                         onChange={(e) => handleSideChange('right', 'hidden_on_small', e.target.checked)}
                                     />
                                 </Form.Group>
                             </Col>
                         </Row>
                {rightSide.type === 'text' && (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label>Strapline</Form.Label>
                        <Form.Control
                            type="text"
                            value={rightSide.content.strapline || ''}
                            onChange={(e) => handleSideChange('right', 'strapline', e.target.value)}
                            placeholder="Voer strapline in"
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Titel</Form.Label>
                        <Form.Control
                            type="text"
                            value={rightSide.content.title || ''}
                            onChange={(e) => handleSideChange('right', 'title', e.target.value)}
                            placeholder="Voer titel in"
                        />
                    </Form.Group>
                    
                                         <Form.Group className="mb-3">
                         <Form.Label>Tekst</Form.Label>
                         
                         {/* Rich Text Editor Toolbar */}
                         <div className="border rounded-top p-2 bg-light">
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => formatRightBodyText('bold')}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 <strong>B</strong>
                             </Button>
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => formatRightBodyText('italic')}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 <em>I</em>
                             </Button>
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => formatRightBodyText('underline')}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 <u>U</u>
                             </Button>
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => formatRightBodyText('insertUnorderedList')}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 • List
                             </Button>
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => formatRightBodyText('insertOrderedList')}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 1. List
                             </Button>
                             <Button
                                 variant="outline-secondary"
                                 size="sm"
                                 className="me-2"
                                 onClick={() => {
                                     const url = prompt('Enter URL:');
                                     if (url) formatRightBodyText('createLink', url);
                                 }}
                                 disabled={rightBodySourceCodeMode}
                             >
                                 🔗 Link
                             </Button>
                             <Button
                                 variant={rightBodySourceCodeMode ? "primary" : "outline-secondary"}
                                 size="sm"
                                 className="ms-auto"
                                 onClick={handleRightBodySourceCodeToggle}
                             >
                                 {rightBodySourceCodeMode ? "WYSIWYG" : "</>"}
                             </Button>
                         </div>
                         
                         {/* Editor Area */}
                         {rightBodySourceCodeMode ? (
                             <Form.Control
                                 ref={rightBodyEditorRef}
                                 as="textarea"
                                 rows={6}
                                 value={rightSide.content.body || ''}
                                 onChange={(e) => handleSideChange('right', 'body', e.target.value)}
                                 style={{
                                     fontFamily: 'monospace',
                                     fontSize: '0.9rem',
                                     borderTop: 'none',
                                     borderTopLeftRadius: '0',
                                     borderTopRightRadius: '0'
                                 }}
                                 placeholder="Voer hier de HTML-code in..."
                             />
                         ) : (
                             <div
                                 ref={rightBodyEditorRef}
                                 contentEditable="true"
                                 onInput={handleRightBodyTextChange}
                                 onClick={handleRightBodyEditorClick}
                                 className="rich-text-editor"
                                 style={{
                                     minHeight: '150px',
                                     maxHeight: '300px',
                                     overflowY: 'auto',
                                     border: '1px solid #ced4da',
                                     borderTop: 'none',
                                     borderBottomLeftRadius: '0.25rem',
                                     borderBottomRightRadius: '0.25rem',
                                     padding: '0.75rem',
                                     backgroundColor: 'white',
                                     outline: 'none'
                                 }}
                                 suppressContentEditableWarning={true}
                             />
                         )}
                     </Form.Group>

                    {/* Action Section */}
                    <h6 className="mb-2 mt-4" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px' }}>
                        Actie (optioneel)
                    </h6>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Type actie</Form.Label>
                        <Form.Select
                            value={rightSide.content.action_type || 'none'}
                            onChange={(e) => handleSideChange('right', 'action_type', e.target.value)}
                        >
                            <option value="none">Niets</option>
                            <option value="button">Knop</option>
                            <option value="form">Formulier</option>
                        </Form.Select>
                    </Form.Group>
                    
                    {rightSide.content.action_type === 'button' && (
                        <>
                            <Row className="mb-3">
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label>Label</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={rightSide.content.button_label || ''}
                                            onChange={(e) => handleSideChange('right', 'button_label', e.target.value)}
                                            placeholder="Voer knop tekst in"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label>Kleur</Form.Label>
                                        <Form.Select
                                            value={rightSide.content.button_color || 'default'}
                                            onChange={(e) => handleSideChange('right', 'button_color', e.target.value)}
                                        >
                                            <option value="default">Groen</option>
                                            <option value="highlight">Oranje</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            
                            <Form.Group className="mb-3">
                                <Form.Label>Link</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={rightSide.content.button_link || ''}
                                    onChange={(e) => handleSideChange('right', 'button_link', e.target.value)}
                                    placeholder="Voer link in"
                                />
                            </Form.Group>
                        </>
                    )}
                    
                                         {rightSide.content.action_type === 'form' && (
                         <Form.Group className="mb-3">
                             <Form.Label>Formulier</Form.Label>
                             <Form.Select
                                 value={rightSide.content.form_shortcode || '[form=1]'}
                                 onChange={(e) => handleSideChange('right', 'form_shortcode', e.target.value)}
                             >
                                 {forms.length > 0 ? (
                                     forms.map(form => (
                                         <option key={form.shortcode} value={form.shortcode}>
                                             {form.name}
                                         </option>
                                     ))
                                 ) : (
                                     <>
                                         <option value="[form=1]">Formulier 1</option>
                                         <option value="[form=2]">Formulier 2</option>
                                         <option value="[form=3]">Formulier 3</option>
                                         <option value="[form=4]">Formulier 4</option>
                                         <option value="[form=5]">Formulier 5</option>
                                     </>
                                 )}
                             </Form.Select>
                         </Form.Group>
                     )}
                </>
            )}
                     </Accordion.Body>
                 </Accordion.Item>
             </Accordion>

             {/* Asset Selector Dialog */}
             <UkiesAssets
                 open={showAssetSelector}
                 setOpen={setShowAssetSelector}
                 onAssetSelect={(asset) => handleAssetSelect(asset, showAssetSelector)}
                 token={apiToken}
             />
         </div>
     );
 } 